import TextWidget from './TextWidget';
import SelectWidget from './SelectWidget';
import DateWidget from './DateWidget';
import EmailWidget from './EmailWidget';
import RadioWidget from './RadioWidget';
import CheckboxWidget from './CheckboxWidget';
import YesNoWidget from './YesNoWidget';
import FileUploadWidget from './FileUploadWidget';
import CalendarDateWidget from './CalendarDateWidget';
import TimeWidget from './TimeWidget';

const widgets = {
  TextWidget,
  SelectWidget,
  DateWidget,
  EmailWidget,
  RadioWidget,
  CheckboxWidget,
  yesNo: YesNoWidget,
  FileUploadWidget,
  CalendarDateWidget,
  TimeWidget,
};

export default widgets;
